import logo from '../../assets/images/starshot-logo.svg';
import newBellIcon from '../../assets/images/new-bell.svg';
import logoutIcon from '../../assets/images/new-box-arrow-right.svg';
import settingIcon from '../../assets/images/new-gear.svg';
import maleSvg from '../../assets/images/male.svg';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { userActions } from '../../store/user';
import { DropDownButton } from '../../components/dropDownButton/dropDownButton.component';
import { useMsal } from '@azure/msal-react';
export const NavBar = ({ isSearchBar, isPostButton, isSettingButton }) => {
    const dispatch = useDispatch()
    const { instance } = useMsal()
    const empName = useSelector(state => state.user.empName)
    return (
        <nav className="header-navbar navbar navbar-expand-lg align-items-center floating-nav navbar-light navbar-shadow">
            <div className="navbar-container d-flex content">
                <div className="bookmark-wrapper d-flex align-items-center w-100 w-xl-40">
                    <ul className="nav navbar-nav d-xl-none w-30 w-xl-auto justify-content-start">
                        <li className="nav-item ml-10 starshot-ring">
                            <a
                                className="nav-link"
                                data-toggle="modal"
                                data-target="#navicon"
                                role="button"
                            >
                                <i className="fas fa-bars ficon" />
                            </a>
                        </li>
                    </ul>
                    <ul className="nav navbar-nav w-40 w-xl-auto justify-content-center justify-content-xl-start">
                        <li className="nav-item">
                            <a className="nav-link">
                                <img
                                    src={logo}
                                    alt="img"
                                    className="w-sm-75p w-md-110p"
                                />
                            </a>
                        </li>
                    </ul>
                    
                </div>
                <div className="bg-etext">
                    <Link className="etext" to="/idea-form">
                    Starshot Innovator Challenge
                        <span className='ml-1'>
                       <svg xmlns="http://www.w3.org/2000/svg" fill='white' height={"1rem"} viewBox="0 0 512 512"><path d="M8.309 189.836L184.313 37.851C199.719 24.546 224 35.347 224 56.015v80.053c160.629 1.839 288 34.032 288 186.258 0 61.441-39.581 122.309-83.333 154.132-13.653 9.931-33.111-2.533-28.077-18.631 45.344-145.012-21.507-183.51-176.59-185.742V360c0 20.7-24.3 31.453-39.687 18.164l-176.004-152c-11.071-9.562-11.086-26.753 0-36.328z"/></svg>
                       </span>
                    </Link>
                </div>
                <ul className="nav navbar-nav align-items-center ml-auto">
                    {/* {isPostButton && (
                        <li className="nav-item mr-10 d-none d-lg-block">
                            <Link to="post-idea"
                                className="btn btn-primary text-white text-uppercase rounded-10 font-10 py-15 waves-effect waves-float waves-light"
                            >
                                Post your ideas
                            </Link>
                        </li>)
                    } */}
                    {isPostButton && (
                        <li className="nav-item mr-10 d-none d-lg-block">
                        <div className="btn-group">
                          <button
                            type="button"
                            className="btn btn-primary text-white text-uppercase font-10 dropdown-toggle dropdown-toggle-split px-2 rounded-10"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                          >
                            Share
                          </button>
                          <div className="dropdown-menu">
                            <Link className="dropdown-item" to="/post-idea">
                            #MyIdea
                            </Link>
                            <Link className="dropdown-item" to="/post-innovation">
                            #MyShowcase
                            </Link>
                            <Link className="dropdown-item" to="/post-challenge">
                            #MyChallenge
                            </Link>
                          </div>
                        </div>
                      </li>
                      )
                    }
                    {/* <li className="nav-item mr-10 d-none d-lg-block avatar border-starshot">
                        <a className="nav-link avatar-content" href="#">
                            <img src={settingIcon} alt="img" />
                        </a>
                    </li> */}
                    <DropDownButton />

                    {/* <li className="nav-item mr-10 d-none d-lg-block avatar border-starshot">
                        <a className="nav-link avatar-content" onClick={() => {
                            dispatch(userActions.logout())
                            instance.logoutRedirect()
                        }}>
                            <img src={logoutIcon} alt="img" />
                        </a>
                    </li> */}
                    {/* <li className="nav-item mr-10 d-none d-lg-block avatar border-starshot">
                        <a className="nav-link avatar-content" href="#">
                            <img src={newBellIcon} alt="img" />
                            <span className="badge badge-pill badge-danger badge-up font-barlow">
                                14
                            </span>
                        </a>
                    </li> */}

                </ul>
            </div>
        </nav>

    )
}